import { Box, Button } from '@mui/material';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import { makeStyles } from 'tss-react/mui';
import { useReadOnly } from 'oidc/userRoles';

const useActionStyle = makeStyles()(theme => ({
  bookingActionBtn: {
    padding: 0,
    lineHeight: 1.85,
    backgroundColor: 'transparent',
    color: theme.palette.system.darkGray,
    '&:hover': {
      backgroundColor: 'transparent',
      '&[aria-label="deny-btn"]': { color: theme.palette.system.darkRed },
      '&[aria-label="approve-btn"]': { color: theme.palette.framework.system.kellyGreen },
    },
  },
  bookingActionContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
  },
  disabled: {
    color: theme.palette.system.lightGrey,
  },
}));

export const ApproveModActions = () => {
  const { classes } = useActionStyle();
   const { readOnly} = useReadOnly();
  return (
    <Box className={classes.bookingActionContainer}>
      <Button
        variant="text"
        disableRipple
        startIcon={<CloseIcon />}
        classes={{ root: classes.bookingActionBtn, disabled: classes.disabled }}
        aria-label="deny-btn"
        disabled={readOnly}
      >{`Deny`}</Button>
      <Button
        variant="text"
        disableRipple
        startIcon={<CheckIcon />}
        classes={{ root: classes.bookingActionBtn, disabled: classes.disabled }}
        aria-label="approve-btn"
        disabled={readOnly}
      >{`Approve`}</Button>
    </Box>
  );
};
